<template>
    <card class="mt-6">
        <div class="card-body">
            <div v-if="preAuth" class="heading flush">To pay following appointment</div>
            <div v-else class="heading flush">Total to pay </div>

            <div class="md:flex md:justify-center md:align-center md:items-center">
                <div class="title-sm">
                    &pound;{{ amountToPay | numFormat('0.00') }}
                </div>
            </div>

            <div>
                <button
                    type="button"
                    role="button"
                    class="btn btn-sm btn-secondary"
                    @click="showModalAndFocusInput()"
                >Apply Voucher</button>
            </div>

        </div>
    </card>
</template>

<script>
    import { mapState } from 'vuex';

    import Card from '../../Block/Card';
    import {Prices} from "../../../lib/Prices";

    export default {
        name: 'appointment-total',

        components: {
            Card,
        },

        computed: {
            ...mapState('appointment', ['appointmentData']),

            ...mapState('voucher', ['voucherCode']),

            total() {
                if (this.appointmentData.clinic.ClinicID == process.env.VUE_APP_VIDEO_CLINIC_ID) {
                    return Prices.video();
                }

                if (this.appointmentData.clinic.ClinicTier === 'CentralLondon') {
                    return Prices.centralLondon();
                }

                if (Prices.hasExceptionPrice() && window._.includes(
                  Prices.exceptionClinicIds(),
                  parseInt(this.appointmentData.clinic.ClinicID))
                ) {
                    return Prices.exception();
                }

                return this.appointmentData.clinic.InsideM25 ? Prices.insideM25() : Prices.outsideM25();
            },

            discount() {
                if (!this.voucherCode) {
                    return 0;
                }

                if (this.appointmentData.clinic.ClinicTier === 'CentralLondon') {
                    return this.voucherCode.discount_central_london;
                }

                if (this.appointmentData.clinic.ClinicTier === 'Virtual') {
                    return this.voucherCode.discount_video;
                }

                return this.appointmentData.clinic.InsideM25 ? this.voucherCode.discount_inside_m25 : this.voucherCode.discount_outside_m25;
            },

            amountToPay() {
                return this.total - this.discount;
            },

            preAuth() {
                return process.env.VUE_APP_PAYMENT_PREAUTH === 'true'
            }
        },

        methods: {
            showModalAndFocusInput() {
                this.showModal('add-voucher');
            }
        },
    }
</script>
